module.exports = __webpack_public_path__ + "img/00007.ddf0997f.webp";